import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PASSKEY_REPOSITORY } from '../domain/repositories/passkey.repository';
import { PasskeyRemoteDatasource } from './datasources/remote/passkey.remote-datasource';
import { PasskeyMapper } from './mappers/passkey.mapper';
import { PasskeyRepositoryImpl } from './repositories/passkey.repository.impl';
import { WebAuthnService } from './services/webauthn.service';

/** Web-only: `apps/mobile` deliberately does not register these providers (WebAuthn is unavailable
 * inside the Capacitor WebView), which is why `AuthStore` injects `PASSKEY_REPOSITORY` optionally.
 * `PasskeyRepositoryImpl` also injects the auth slice's `AuthMapper`, so `provideAuthData()` must
 * be registered alongside this -- it always is, since passkeys only exist for authenticated apps. */
export function providePasskeysData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    PasskeyRemoteDatasource,
    PasskeyMapper,
    WebAuthnService,
    { provide: PASSKEY_REPOSITORY, useClass: PasskeyRepositoryImpl },
  ]);
}
